import { widgetFontStack } from "@sagot/constants";
import { ChatTheme } from "@sagot/chat";
import { useTranslation } from "@sagot/i18n";
import { Segmented } from "@sagot/ui";
import { useState } from "react";
import { useWidgetFontStylesheet } from "./font-picker";
import { MessengerHomeFrame, WidgetHomeFrame } from "./home-preview-frames";
import { brandContrast, type WidgetForm } from "./widget-model";

const K = "deployKnowledge.widgetStudio.home.preview";

type Channel = "widget" | "messenger";

interface HomePreviewProps {
  form: WidgetForm;
  agentName: string;
  /** The tenant's name: the Facebook Page shown in the Messenger frame. */
  pageName: string;
}

/** Live preview of the Home draft: the widget opening on Home, or Messenger's Get Started + menu. */
export function HomePreview({ form, agentName, pageName }: HomePreviewProps) {
  const { t } = useTranslation();
  const [channel, setChannel] = useState<Channel>("widget");
  const contrast = brandContrast(form.appearance.primary_color);
  const { font } = form.appearance;
  useWidgetFontStylesheet(font);
  return (
    <section aria-label={t(`${K}.live`)} data-testid="home-preview" className="space-y-4">
      {form.home.enabled ? null : (
        <p role="status" className="rounded-md bg-info-soft p-3 text-xs text-fg-muted">
          {t(`${K}.off`)}
        </p>
      )}
      <Segmented
        aria-label={t(`${K}.channel`)}
        value={channel}
        onValueChange={setChannel}
        options={[
          { value: "widget", label: t(`${K}.widget`) },
          { value: "messenger", label: t(`${K}.messenger`) },
        ]}
      />
      <div className="rounded-lg bg-sunken p-4">
        <ChatTheme primary={form.appearance.primary_color} onPrimary={contrast.onPrimary} radius={`${String(form.appearance.radius_px)}px`} font={widgetFontStack(font) ?? undefined}>
          {channel === "widget" ? <WidgetHomeFrame form={form} agentName={agentName} /> : <MessengerHomeFrame form={form} pageName={pageName} />}
        </ChatTheme>
      </div>
      <p className="text-xs text-fg-subtle">{t(`${K}.footer`)}</p>
    </section>
  );
}
